"use client";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import Button from "@elements/Button";
import Input from "@elements/Input";
import TextArea from "@elements/TextArea";
import Image from "next/image";
import { FormProvider, useForm } from "react-hook-form";
import Autocomplete from "@elements/Autocomplete";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { addContactSchema } from "@utils/validations";
import { contactUsType } from "@utils/staticData";
import { myAxios } from "@utils/axios";
import { setMessage } from "@redux/slices/message";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";

type FormType = {
  fullName: string;
  phone: string;
  subject: { id: number; label: string };
  message: string;
};

const ContactUsPage = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const handleAddTicket = (values: FormType) => {
    myAxios
      .post("/contact", values)
      .then((res) => {
        console.log(res.data);
        dispatch(setMessage({ message: res.data.message }));
        router.push("/");
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
  const methods = useForm<FormType>({
    resolver: yupResolver(addContactSchema),
    defaultValues: {
      fullName: "",
      phone: "",
      message: "",
    },
  });
  return (
    <div className="flex flex-col md:flex-row items-center">
      <FormProvider {...methods}>
        <form
          className="w-full md:w-7/12 flex flex-col gap-5 p-4"
          onSubmit={methods.handleSubmit(handleAddTicket)}
        >
          <span className="font-bold text-lg">با ما در ارتباط باشید</span>
          <div className="w-full flex flex-col gap-6 child:min-w-full last:child:min-w-min">
            <Input name="fullName" autoFocus label="نام و نام‌خانوادگی" />
            <Input name="phone" label="شماره همراه" />
            <Autocomplete
              name="subject"
              label="موضوع پیام"
              options={contactUsType}
            />
            <TextArea name="message" label="پیام" />
            <Button type="submit">ارسال</Button>
          </div>
        </form>
      </FormProvider>
      <div className="w-full md:w-5/12 flex flex-col gap-10 py-8 items-center">
        <Image
          src="/images/contact.svg"
          width={200}
          height={200}
          alt="سفارش تابلو چنلیوم"
          className="w-full h-96 hidden md:flex"
        />
        <div className="flex flex-col gap-4">
          <div className="flex gap-5">
            <span>شماره تماس: </span>
            <a href="tel:09112076139">۰۹۱۱۲۰۷۶۱۳۹</a>
          </div>
          <div className="flex gap-3">
            <span>شبکه‌های اجتمائی: </span>
            <a
              href="https://wa.me/989112076139"
              target="_blank"
              className="text-[#0dc143] text-2xl"
            >
              <FaWhatsapp />
            </a>
            <a
              target="_blank"
              href="https://t.me/+989112076139"
              className="text-[#269eda] text-2xl"
            >
              <FaTelegramPlane />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
